import React, { useState, useMemo, useRef, useEffect, useContext } from 'react';
import { Amplify, API, graphqlOperation, Storage } from 'aws-amplify';
import { createGuidanceContent, updateGuidanceContent } from '../graphql/mutations';
import { getGuidanceContent } from '../graphql/queries';
import 'quill/dist/quill.snow.css';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { useParams, useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { UserContext } from '../App';
import axios from 'axios';


const useStyles = makeStyles((theme) => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2),
    },
    textField: {
        margin: theme.spacing(1),
        width: '100%',
    },
    submitButton: {
        margin: theme.spacing(2, 0),
    },
}));



const AddGuidanceContentForm = ({ guidanceId }) => {
    const params = useParams();
    const classes = useStyles();
    const [pageTitle, setPageTitle] = useState('');
    const [content, setContent] = useState('');
    const quillRef = useRef(null);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const pageId = queryParams.get('pageId');
    const [confirmationMessage, setConfirmationMessage] = useState('');
    const userId = useContext(UserContext);

    useEffect(() => {
        const fetchGuidanceContent = async () => {
            if (pageId) {
                try {
                    const result = await API.graphql(
                        graphqlOperation(getGuidanceContent, {
                            id: pageId
                        })
                    );
                    const { title, content } = result.data.getGuidanceContent;
                    setPageTitle(title);
                    setContent(content);
                } catch (error) {
                    console.error('Error fetching guidance content', error);
                }
            }
        };
        fetchGuidanceContent();
    }, [pageId]);

    const selectLocalFile = async (type) => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', type === 'image' ? 'image/*' : 'video/*');
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            if (file) {
                const resizedFile = type === 'image' ? await resizeImage(file) : file;
                const fileURL = await uploadToS3(resizedFile);
                insertToEditor(fileURL, type);
            }
        };
    };


    const insertToEditor = (url, type) => {
        const quill = quillRef.current.getEditor();
        const index = quill.getSelection().index || 0;
        if (type === 'image') {
            quill.insertEmbed(index, 'image', url, 'user');
        } else if (type === 'video') {
            quill.insertEmbed(index, 'video', url, 'user');
        }
    };

    const modules = useMemo(() => ({
        toolbar: {
            container: [
                [{ header: [1, 2, 3, false] }],
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['image', 'video', 'code-block']
            ],
            handlers: {
                image: () => selectLocalFile('image'),
                video: () => selectLocalFile('video'),
            }
        }
    }), []);


    const handleQuillChange = (value) => {
        setContent(value);
    };

    const uploadToS3 = async (file) => {
        const key = 'contentImages/' + uuidv4() + '-' + file.name;

        try {
            const response = await Storage.put(key, file, {
                contentType: file.type,
                level: 'public',
            });

            const imageURL = `https://acecuraapp-storage180506-staging.s3.eu-west-2.amazonaws.com/public/${response.key}`;
            return imageURL;
        } catch (error) {
            console.error('Error uploading to S3', error);
        }
    }


    const resizeImage = async (file, maxWidth = 400, maxHeight = 400) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                let width = img.width;
                let height = img.height;

                if (width > height) {
                    if (width > maxWidth) {
                        height *= maxWidth / width;
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width *= maxHeight / height;
                        height = maxHeight;
                    }
                }

                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob((blob) => {
                    resolve(new File([blob], file.name, {
                        type: 'image/jpeg',
                        lastModified: Date.now()
                    }));
                }, 'image/jpeg', 0.95);
            };
            img.onerror = reject;
        });
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        // Find and replace "<p><br></p>" with "<br>"
        //This helps with better spacing for content.
        var modifiedContent = content.replace(/<p><br><\/p>/g, "<br>");
        modifiedContent = modifiedContent.replace(/<\/p><br>/g, "<\/p>");
        modifiedContent = modifiedContent.replace(/<\/h2><br>/g, "<\/h2>");
        modifiedContent = modifiedContent.replace(/<h2><br><\/h2>/g, "");

        let cleanedContent = content.replace(/<br\s*\/?>/gi, " ").replace(/<\/li>/gi, " ");
        const textContent = cleanedContent.replace(/<\/?[^>]+(>|$)/g, "").replace(/\n/g, " ");

        // console.log("Text Content Without HTML Tags:", textContent);
        // console.log("Text Content WITH HTML Tags:", modifiedContent);

        try {
            const response = await axios.post('https://gptapi.acecura.com/api/embeddings',
              {
                content: textContent,
                userid: userId,
                contenttype: "Guidance Article"
      
              },
              {
                headers: { 'x-api-key': '56a613f1-9d5a-4cc8-8a69-ad06e603397d' }
              });
      
          } catch (error) {
            console.error('Error creating embeddings:', error);
          }

        try {
            if (pageId) {
                // Update existing guidance content
                await API.graphql(
                    graphqlOperation(updateGuidanceContent, {
                        input: {
                            id: pageId,
                            title: pageTitle,
                            content: modifiedContent,
                        },
                    })
                );
                setConfirmationMessage('Successfully updated guidance content!');
            } else {
                // Create new guidance content
                await API.graphql(
                    graphqlOperation(createGuidanceContent, {
                        input: {
                            guidanceID: params.guidanceId,
                            title: pageTitle,
                            content: modifiedContent,
                            order: 1,
                        },
                    })
                );
                setConfirmationMessage('Successfully added new guidance content!');

                // Reset form fields after successful submission
                setPageTitle('');
                setContent('');

            }


        } catch (error) {
            console.error(error);
            setConfirmationMessage('Failed to submit guidance content. Please try again.');
        }

    };

    return (
        <form className={classes.form} onSubmit={handleSubmit}>
            <TextField
                className={classes.textField}
                label="Page Title"
                value={pageTitle}
                onChange={(event) => setPageTitle(event.target.value)}
            />
            <ReactQuill
                ref={quillRef}
                value={content}
                onChange={handleQuillChange}
                placeholder="Enter content..."
                modules={modules}
                style={{ width: '600px', minHeight: '300px' }}
            />
            {confirmationMessage && (
                <p>{confirmationMessage}</p>
            )}
            <Button
                className={classes.submitButton}
                variant="contained"
                color="primary"
                type="submit"
            >
                Submit
            </Button>
        </form>
    );
};

export default AddGuidanceContentForm;
